<div class="bg-primary-light py-10 lg:py-16">
  <form [formGroup]="searchForm" (ngSubmit)="onSubmitForm()" class="container">
    <div class="w-full p-2.5 lg:py-3 border-2 border-primary bg-white rounded-xl"
      [ngClass]="{'transition': isFilterOpen}">
      <div class="flex flex-col gap-1.5 lg:gap-0 lg:flex-row lg:items-center"
        [ngClass]="[isFilterOpen ? 'border-b-2 border-gray-100 pb-3': 'border-b-0 pb-0 duration-75']">
        <braidsbook-address-search formControlName="location" class="w-full" />
        <braidsbook-hairstyle-search formControlName="hairstyle" class="w-full" />
        <braidsbook-date-picker formControlName="availabilityDate" class="w-full" />
        <div class="flex items-center h-11 gap-1.5 mt-2 lg:mt-0">
          <button type="submit"
            class="lg:ml-2 w-full lg:w-auto rounded-full bg-primary text-sm text-white min-h-11 px-6 lg:px-8 lg:hover:bg-main-600 transition">
            {{ 'HAIRDRESSERS.SEARCH_BUTTON' | translate }}
          </button>
          <button (click)="onResetForm()" type="button"
            class="w-full lg:w-auto rounded-full text-sm min-h-11 px-6 lg:px-8 lg:ml-1.5 bg-gray-100 hover:bg-gray-200 transition">
            {{ 'HAIRDRESSERS.CLEAR_BUTTON' | translate }}
          </button>
          <button type="button" class="rounded-full w-11 h-11 flex items-center justify-center text-gray-700"
            (click)="toggleFilters()">
            <icon-filter [size]="20" [ngClass]="[isFilterOpen ? 'rotate-90 transition' : 'rotate-0 transition']" />
          </button>
        </div>
      </div>

      @if (isFilterOpen) {
      <div class="overflow-hidden transition" [ngClass]="[isFilterOpen ? 'min-h-20 lg:h-[115px]' : 'h-0']">
        <div class="pt-5 pb-3.5 lg:py-3 flex flex-col gap-5 lg:flex-row lg:items-start lg:gap-10">
          <braidsbook-input-radio class="text-sm" formControlName="placeOfReception" [name]="'placeOfReception'"
            [label]="'HAIRDRESSERS.PLACE_OF_RECEPTION_LABEL' | translate" [options]="placeOfReceptions" />
          <div>
            <div class="mb-2.5">{{ 'HAIRDRESSERS.OPENING_HOURS_LABEL' | translate }}</div>
            <div class="flex items-center gap-2.5 w-full">
              <div class="flex flex-col flex-1">
                <label for="minTime" class="text-sm font-medium">{{ 'HAIRDRESSERS.MIN_TIME_LABEL' | translate }}</label>
                <input type="time" name="minTime" id="minTime"
                  [placeholder]="'HAIRDRESSERS.TIME_PLACEHOLDER' | translate" formControlName="minTime"
                  class="border border-gray-300 h-12 px-4 w-full lg:min-w-32 rounded-lg">
              </div>
              <div class="flex flex-col flex-1">
                <label for="maxTime" class="text-sm font-medium">{{ 'HAIRDRESSERS.MAX_TIME_LABEL' | translate }}</label>
                <input type="time" name="maxTime" id="maxTime"
                  [placeholder]="'HAIRDRESSERS.TIME_PLACEHOLDER' | translate" formControlName="maxTime"
                  class="border border-gray-300 bord h-12 px-4 w-full lg:min-w-32 rounded-lg">
              </div>
            </div>
          </div>
        </div>
      </div>
      }

    </div>
  </form>
</div>

<div class="py-7 lg:py-0" [ngClass]="[activeView() === 'list' ? 'max-lg:container' : 'pb-0']">
  <div class="flex mb-5 items-center justify-start lg:hidden" [ngClass]="[activeView() === 'list' ? '' : 'px-4']">
    <div class="p-1 rounded-lg bg-gray-100 flex items-center gap-1 text-sm font-medium">
      <button (click)="activeView.set('list')" class="flex items-center gap-1.5 py-2 px-3"
        [ngClass]="{'bg-white rounded-md': activeView() === 'list'}">
        <icon-list [size]="18" />
        <span>{{ 'HAIRDRESSERS.LIST_VIEW' | translate }}</span>
      </button>
      <button (click)="activeView.set('map')" class="flex items-center gap-1.5 py-2 px-3"
        [ngClass]="{'bg-white rounded-md': activeView() === 'map'}">
        <icon-map [size]="18" />
        <span>{{ 'HAIRDRESSERS.MAP_VIEW' | translate }}</span>
      </button>
    </div>
  </div>
  @if (activeView() === 'list') {
  <div class="flex gap-5">
    @if (isLoading()) {
    <div class="flex-1 lg:p-10">
      <braidsbook-hairdressers-list-skeleton />
    </div>
    <div class="flex-1 bg-gray-100 animate-pulse hidden lg:block"></div>
    } @else {
    <div class="flex-1 lg:p-10">
      <braidsbook-hairdressers-list [hairdresserResponse]="hairdressersResponse()" />
    </div>
    <div class="min-h-[568px] flex-1 hidden lg:block sticky top-[500px]">
      <braidsbook-map [hairdressers]="hairdressersResponse().data" class="w-full" />
    </div>
    }
  </div>
  } @else if (activeView() === 'map') {
  <div class="h-[568px] flex-1 lg:block">
    @if (isLoading()) {
    <div class="flex-1 bg-gray-200 animate-pulse hidden lg:block"></div>
    } @else {
    <braidsbook-map [hairdressers]="hairdressersResponse().data" class="w-full" />
    }
  </div>
  }
</div>